import { createSlice } from "@reduxjs/toolkit";
import { affiliations } from "../../../types/core_ibass";

export const allAffiliations = createSlice({
  name: "all_affiliations",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: affiliations;
      }[],
      data: [] as affiliations,
    },
  },
  reducers: {
    update_affiliation: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload;
    },
    add_affiliation: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    addToPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    remove_affiliation: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    replace_affiliation: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_affiliation: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_affiliation,
  add_affiliation,
  addToPaginationHistory,
  remove_affiliation,
  replace_affiliation,
  clear_affiliation,
} = allAffiliations.actions;

export default allAffiliations.reducer;
